export default {
  methods: {
    $isEmptyObject (obj) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          return false
        }
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/objectIsEmpty.js